import { useState, useEffect } from "react";
import { useAppContext } from "../../context";
import { fetchRegioni } from "./api";

// Carica una volta la lista delle regioni italiane dal servizio select2.
// In caso di errore (es. endpoint non disponibile) ritorna lista vuota: i
// consumatori applicano un fallback ai valori presenti nei documenti.
export const useRegioni = () => {
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";
  const [regioni, setRegioni] = useState([]);

  useEffect(() => {
    let active = true;
    fetchRegioni(env)
      .then((list) => {
        if (active) setRegioni(list);
      })
      .catch((e) => {
        console.error("Errore caricamento regioni:", e);
      });
    return () => {
      active = false;
    };
  }, [env]);

  return regioni; // [{ id, nome, codice, capoluogo, text }]
};
